import gql from 'graphql-tag'

export default config =>
  async (payload = {}) => {
    const {
      client,
      table,
      field = () => {
        throw new Error('is-unique: Field is required')
      }
    } = config

    const { value } = payload

    const { data } = await client.query({
      fetchPolicy: 'network-only',
      query: gql`
      query($val: String!) {
        res: ${table}(where: { ${field}: { _ilike: $val } }) {
          id
        }
      }
    `,
      variables: {
        val: value
      }
    })
    return !(data.res && data.res.length > 0)
  }
